import React, { Component } from "react"
import { Route, Switch, Redirect } from "react-router-dom"
import Dashboard from "./dashboard"
import Bill from "./bill"
import DataManage from "./data_statistics"
import BypassAccount from "./bypass-account"
import Organization from "./organization"
import Baseline from "./baseline"
import Template from "./template"
export default class extends Component {
  render() {
    const { match } = this.props
    return (
      <Switch>
        <Route path={`${match.url}/dashboard`} component={Dashboard} />
        {/*长的 url 可能会被短的 path 匹配拦截到, 并进入当前匹配节点的 Component 中继续查询匹配*/}
        <Route path={`${match.url}/bill`} component={Bill} />
        <Route path={`${match.url}/data_statistics`} component={DataManage} />
        <Route path={`${match.url}/bypass-account`} component={BypassAccount} />
        <Route path={`${match.url}/organization`} component={Organization} />
        <Route path={`${match.url}/baseline`} component={Baseline} />
        <Route path={`${match.url}/template`} component={Template} />
        <Redirect from='*' to={`${match.url}/dashboard`} />
      </Switch>
    )
  }
}




// WEBPACK FOOTER //
// ./src/app/pages/preview/index.js